import React, { useEffect, useState } from 'react';
import Breadcrumbs from './Breadcrumbs';
import CmsPage from './CmsPage';
import { applySeo } from '../utils/seoManager';
import './BlogPostView.css';

const BlogPostView = ({ slug }) => {
  const [post, setPost] = useState(null);

  useEffect(() => {
    fetch(`/api/blog/slug/${slug}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        setPost(data);
        if (data) {
          applySeo({
            seoTitle: data.seoTitle || data.title,
            metaDescription: data.metaDescription || data.excerpt,
            canonicalUrl: data.canonicalUrl,
            ogTitle: data.ogTitle,
            ogDescription: data.ogDescription,
            ogImage: data.ogImage || data.featuredImage,
            ogType: 'article',
          });
        }
      });
  }, [slug]);

  if (!post) return <div className="blog-post-loading">Loading...</div>;

  return (
    <article className="blog-post-view">
      <Breadcrumbs items={[
        { name: 'Home', url: '/' },
        { name: 'Blog', url: '/blog' },
        { name: post.title, url: '' },
      ]} />
      {post.featuredImage && (
        <img className="blog-post-featured" src={post.featuredImage} alt={post.featuredImageAlt || post.title} />
      )}
      <h1>{post.title}</h1>
      <div className="blog-post-meta">
        <time>{new Date(post.publishDate).toLocaleDateString()}</time>
        {post.author && <span> · {post.author}</span>}
        {post.categories?.length > 0 && <span> · {post.categories.join(', ')}</span>}
      </div>
      {post.content && <div className="blog-post-content" dangerouslySetInnerHTML={{ __html: post.content }} />}
      {post.sections?.length > 0 && <CmsPage page={post} />}
    </article>
  );
};

export default BlogPostView;
